import { getCasinoGameDetails, getMatchExposure, getMyBets } from "../../../apiservices/CasionApi";
import { useState, useEffect, useCallback } from "react";
import CasinoHeading from "../../casinoComponents/casinoHeading";
import BetTableDragon from "../../casinoComponents/betTableDragon";
import VideoBox from "../../casinoComponents/videoBox";
import MyBet from "../../casinoComponents/myBet";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import DragonTigerCardsOverlay from "../../casinoComponents/videoBox/overlays/DragonTigerCardsOverlay";
import ViewMoreModal from "../../../components/ViewMoreModal";
import "../../../styles/games/dt20.css";
import ResultDragonTiger202 from "../resultui/resultDragonTiger202/ResultDragonTiger202";
import PlaceBet from "../../casinoComponents/placeBet/NoBet";

export default function DragonTiger202() {
  const [gameData, setGameData] = useState(null);
  const [betValue, setBetValue] = useState("");
  const [selectedBetData, setSelectedBetData] = useState(null);
  const [selectedSelection, setSelectedSelection] = useState("");
  const [exposures, setExposures] = useState({});
  const [myBets, setMyBets] = useState([]);
  const [showPlaceBet, setShowPlaceBet] = useState(false);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);

  useEffect(() => {
    const fetchGameData = async () => {
      try {
        const data = await getCasinoGameDetails("dt202");
        setGameData(data);
      } catch (err) {
        console.error("Error fetching game data:", err);
      }
    };

    fetchGameData();
    const interval = setInterval(fetchGameData, 1500);
    return () => clearInterval(interval);
  }, []);

  const subData = gameData?.data?.data?.sub || gameData?.data?.sub || [];

  // Callback function to handle click on betting options
  const handleBetClick = (label, value, betData) => {
    setBetValue(value);
    setSelectedBetData(betData);
    setSelectedSelection(betData?.nat || label);
    setShowPlaceBet(true);
  };

  const fetchExposure = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = gameData?.data?.data?.mid?.toString() || gameData?.data?.mid?.toString() || gameData?.mid?.toString();

      if (userId && matchId) {
        const response = await getMatchExposure(userId, matchId);
        if (response.success && response.data) {
          const exposureMap = {};
          response.data.forEach((item) => {
            exposureMap[item.team_name] = parseFloat(item.exposure_amount) || 0;
          });
          setExposures(exposureMap);
        }
      }
    } catch (error) {
      console.error('Error fetching exposure:', error);
    }
  }, [gameData?.data?.data?.mid, gameData?.data?.mid, gameData?.mid]);

  const fetchMyBetsData = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
      const matchId = gameData?.data?.data?.mid?.toString() || gameData?.data?.mid?.toString() || gameData?.mid?.toString();

      if (userId && matchId) {
        const response = await getMyBets(userId, matchId);
        if (response.success && response.bets) {
          const formattedBets = response.bets.map((bet) => ({
            // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
            description: bet.description ?? bet.game_name ?? bet.gameName,
            userName: bet.userName ?? bet.username,
            placeDate: bet.placeDate ?? bet.created_at,
            matchedBet: bet.player_name || bet.selection || "",
            odds: bet.odds || "0",
            stake: bet.stake || "0",
            type: bet.type || null
          }));
          setMyBets(formattedBets);
        }
      }
    } catch (error) {
      console.error('Error fetching my bets:', error);
    }
  }, [gameData?.data?.data?.mid, gameData?.data?.mid, gameData?.mid]);

  useEffect(() => {
    const matchId = gameData?.data?.data?.mid?.toString() || gameData?.data?.mid?.toString() || gameData?.mid?.toString();
    if (!matchId) return;

    const timeoutId = setTimeout(() => {
      fetchExposure();
      fetchMyBetsData();
    }, 2000);

    const intervalId = setInterval(() => {
      fetchExposure();
      fetchMyBetsData();
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };
  }, [gameData?.data?.data?.mid, gameData?.data?.mid, gameData?.mid, fetchExposure, fetchMyBetsData]);

  const handleBetPlaced = () => {
    setBetValue("");
    setSelectedBetData(null);
    setSelectedSelection("");
    setShowPlaceBet(false);
    fetchExposure();
    fetchMyBetsData();
  };

  const feed = gameData?.data?.data ?? gameData?.data ?? {};
  const roundId = feed?.mid || gameData?.mid;
  const iframeSrc = "https://stream-s-43.uhdmovies.online/casino-stream?id=dt202";

  return (
    <CasinoTableLayout
      tableClass="dt20"
      rightSide={<MyBet bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />}
    >
      <>
        <CasinoHeading name="20-20 Dragon Tiger 2" roundId={roundId || ""} placedBetCount={myBets.length} />

        <VideoBox
          iframeSrc={iframeSrc}
          timerValue={feed?.lt}
          gameType="dt202"
          cardsOverlay={feed?.card != null ? <DragonTigerCardsOverlay card={feed.card} /> : null}
        />

        {/* Reference renders .casino-detail once the feed has a round (casinoData.mid) */}
        {roundId ? (
          <div className="casino-detail">
            <BetTableDragon data={subData} onBetClick={handleBetClick} exposures={exposures} myBets={myBets} remark={feed?.remark} />{" "}
            <CasinoLastResult
              gameType="dt202"
              data={gameData?.lrs || []}
              gameData={gameData}
              viewAllLink="/admin/reports/casinoresult/dt202"
              resultComponent={<ResultDragonTiger202 data={gameData?.lrs || []} />}
            />
          </div>
        ) : null}

        {/* Admin panel places no bets: PlaceBet is the NoBet stub (renders nothing) */}
        {showPlaceBet && betValue && selectedBetData && (
          <PlaceBet
            betValue={betValue}
            playerName={selectedSelection}
            playerNameForApi={selectedBetData?.nat || selectedSelection}
            setShowPlaceBet={setShowPlaceBet}
            gameId={gameData?.data?.data?.mid?.toString() || gameData?.data?.mid?.toString() || gameData?.mid?.toString() || "98765"}
            gameName="dt202"
            roundId={gameData?.data?.data?.mid || gameData?.data?.mid || gameData?.mid || 0}
            selection={selectedSelection}
            betData={selectedBetData}
            onBetPlaced={handleBetPlaced}
          />
        )}
      </>
      <ViewMoreModal
        show={showViewMoreModal}
        onHide={() => setShowViewMoreModal(false)}
        title="View More"
        sectionKey="dt202"
      />
    </CasinoTableLayout>
  );
}
